/**
 * @fileoverview GET handler for the "/apps/:app_group_id/encryption_settings/generate_external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { GenerateExternalIdResult } from "./types";

export const appsAppGroupIdEncryptionSettingsGenerateExternalId =
  "/apps/:app_group_id/encryption_settings/generate_external_id" as const;

export const getGenerateExternalId = reactQueryFetcherAdapter(
  appsAppGroupIdEncryptionSettingsGenerateExternalId,
  (signal: AbortSignal, appGroupId: string): Promise<GenerateExternalIdResult> => {
    return fetch(`/apps/${appGroupId}/encryption_settings/generate_external_id`, "GET", {}, { signal });
  }
);
